import { Dialog, MenuItem,Select,Box,InputLabel,Stack, TextField,Tooltip, IconButton, Autocomplete,Typography } from "@mui/material";
import { useState,useEffect } from "react";
import Dropzone from "./fileDropZone";
import PublishIcon from '@mui/icons-material/Publish';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import { fetchSources, fetchAuthors, addItem } from '../supabaseApi'
import axios from "axios";
import AttachFileIcon from '@mui/icons-material/AttachFile';

const UploadModal = ({modalOpen,handleUploadModal})=>{
  const [allSources,setAllSources] = useState([])
  const [allAuthors,setAllAuthors] = useState([])

  useEffect(async()=>{
    if (!modalOpen) return
    try {
      let sources = await fetchSources()
      console.log(sources)
      setAllSources(sources.filter(s => s?.length))

      let authors = await fetchAuthors()
      console.log(authors)
      setAllAuthors(authors.map(a => a.name))
    } catch (err) {
      console.log(err)
    }
  },
  [modalOpen])
    const [fileData,setFileData] = useState({})
    const [status,setStatus] = useState('')
    const [loading,setLoading] = useState(false)
    const [oks,setOks] = useState([])
    const [errs,setErrs] = useState([])
    const [authorsInput,setAuthorsInput] = useState([])
    const [inputData,setInputData] = useState({'mediatype':1,title:'',year:2000,desc:'',source:'',notes:'',_authors:[]})
    const handleFileData=(_data)=>{
      console.log(_data)
        setFileData(_data)
    }
    useEffect(() => {
      setFileData({'mediatype':1,title:'',year:2000})
    }, [])
    useEffect(()=>{
      if (!fileData?.name) return
      setStatus('')
    },[fileData])

    return <Dialog 
    open={modalOpen}
    onClose={handleUploadModal}
    sx={{cursor:(loading ? 'wait' : 'pointer' )}}
    >
   
    <Box sx={{display:'flex',justifyContent:'center'}} pt={4}>
        
    <Dropzone handleFileData={handleFileData} fileData={fileData}/>
 
    </Box>
    {fileData.length && <Box  
    sx={{display:'flex',flexDirection:'column',justifyContent:'start',maxHeight:'5vh',overflowY:'auto',padding:'1vh 0'}}>
    {fileData.map((file,i)=><span
      style={{fontSize: '10px',
      textAlign:'left',
      justifyContent: 'space-between',
      display: 'flex',
      padding: '0 4vw',
      color:(oks.includes(i) && !errs.includes(i)) ? 'green'  : errs.includes(i) ? 'red' : 'grey'
    }}
    ><Typography
    sx={{fontSize: '10px'}}
      >{file.name}</Typography>
    
      {
      (oks.includes(i) && !errs.includes(i)) 
      ? <CheckIcon 
      size={1}
    sx={{fontSize: '12px'}}/>
    : errs.includes(i) 
    ?
    <ErrorIcon
    size={1}
    sx={{fontSize: '12px'}}
    /> :
    <AttachFileIcon 
    size={1}
    sx={{fontSize: '12px'}}/>
  
  }
    </span>)}
    </Box>
    }
        <Box sx={{display:'flex'}} p={4}>
            <Stack>
        <InputLabel id="mediatype-label">Media Type</InputLabel>
           <Select
          id="mediatype"
          value={inputData.mediatype}
          label="Media Type"
          onChange={(e)=>{setInputData(data=>({...data,"mediatype": e.target.value}))}}      
        >
       <MenuItem value={1}>Photograph</MenuItem>
          <MenuItem value={2}>Journal</MenuItem>
          <MenuItem value={3}>Ephemera</MenuItem>
          </Select>
          </Stack>

          <Stack>
        <InputLabel id="title-label">Title</InputLabel>
           <TextField
            placeholder="Item title..."
           id='title'
           value={inputData.title}
           onChange={(e)=>{setInputData(data=>({...data,"title": e.target.value}))}}
           />
          </Stack>

          <Stack>
        <InputLabel id="year-label">Year</InputLabel>
           <TextField
            type='number'
           id='year'
           value={inputData.year}
           onChange={(e)=>{setInputData(data=>({...data,"year": e.target.value}))}}
           />
          </Stack>
 
    </Box>
    <Box sx={{display:'flex'}} px={4}>
          <Stack width={'100%'}>
        <InputLabel id="title-label">Description</InputLabel>
           <TextField
            placeholder="Item description..."
           id='title'
           value={inputData.desc}
           onChange={(e)=>{setInputData(data=>({...data,"desc": e.target.value}))}}
           />
          </Stack>
          <Stack width={'100%'}>
        <InputLabel id="title-label">Source</InputLabel>
           <Autocomplete
            freeSolo
            placeholder="Item source..."
            id='source'
            value={inputData.source}
            options={allSources}
          
            onChange={(e,newVal)=>{
              
              setInputData(data=>({...data,"source": newVal}))}
            }

            renderInput={(params) => <TextField {...params}  />}

            getOptionLabel={(option) => option || ""}
            onInputChange={(e,newVal)=>{
              setInputData(data=>({...data,"source": newVal}))
              
            }
          }
            getOptionSelected={(option, value) => {
              const optionTitle = typeof option === "string" ? option : option.title;
              const valueTitle = typeof value === "string" ? value : value.title;
              return optionTitle === valueTitle;
    }}

           />
          </Stack>

          <Stack width={'100%'}>
        <InputLabel id="title-label">Author(s)</InputLabel>
           <Autocomplete
            freeSolo
            multiple
            placeholder="Item author(s)..."
            id='source'
            value={inputData._authors}
            options={allAuthors}
          
            onChange={(e,newVal)=>{
              console.log(newVal)
              setInputData(data=>({...data,"_authors": newVal}))}
            }

            renderInput={(params) => <TextField {...params}  />}

            getOptionLabel={(option) => option || ""}
            onInputChange={(e,val)=>{
              console.log(val)
            }
          }
            getOptionSelected={(option, value) => {
              const optionTitle = typeof option === "string" ? option : option.title;
              const valueTitle = typeof value === "string" ? value : value.title;
              return optionTitle === valueTitle;
    }}

           />
          </Stack>
      </Box>
      <Box>
      <Stack  p={4}>
        <InputLabel id="title-label">Notes</InputLabel>
        <TextField
            placeholder="Item notes..."
           id='notes'
           value={inputData.notes}
           onChange={(e)=>{setInputData(data=>({...data,"notes": e.target.value}))}}
           />
          </Stack>
      </Box>
    <Box sx={{display:'flex',justifyContent:'center'}} pb={4}>
<IconButton 
sx={{cursor:(loading ? 'wait' : 'pointer' )}}
onClick={async()=>{
  setOks([])
  setErrs([])
    if (loading || !fileData?.length) return
  let req_arr = []
    setLoading(true)
  fileData.forEach(file=>{
    req_arr.push(addItem({
      ...inputData,
      image: file.name
    }))
  })
    req_arr.forEach(async(req,i) =>{
     try {
       await req
       setOks(_oks=>[..._oks,i])
     } catch(err) {
       console.log(err)
       setErrs(_errs=>[..._errs,i])
     }
     if (i===req_arr.length-1){
      setLoading(false)
      if (oks.length===req_arr.length-1){
        setInputData({'mediatype':1,title:'',year:2000,desc:'',source:'',notes:'',_authors:[]})
        setFileData({})
        handleUploadModal()
      }
     }
    })


}}>
{
  status==='good' ? 
  <Tooltip title='item added'>
  <CheckIcon fontSize={'large'} style={{color:'green'}}/>
  </Tooltip>
  : status==='bad' ? 
  <Tooltip title='error'>
  <ErrorIcon fontSize={'large'} style={{color:'red'}}/>
  </Tooltip>
  : 
  <Tooltip title='submit'>
  <PublishIcon fontSize={'large'} />
  </Tooltip>
}
 
 </IconButton>
 </Box>
        </Dialog>

}

export default UploadModal